import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const hostInfo = createSlice({
	name: "hostInfo",
	initialState: {
		loading: false,
		error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
		},
		items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			totalRows: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			if(action.payload?.pagination)
			{
				state.pagination = action.payload.pagination;
			}
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			action.payload.id = parseInt(action?.payload?.id);
			let objIndex = state.items.findIndex((item => item.id === action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			action.payload = parseInt(action?.payload);
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const hostInfoActions = hostInfo.actions;
//Reducers
export const hostInfoReducer = hostInfo.reducer;
//Selectors
export const hostInfoItemsSelector = (state) => state.hostInfo.items;
export const hostInfoLoadingSelector = (state) => state.hostInfo.loading;
export const hostInfoErrorSelector = (state) => state.hostInfo.error;
export const hostInfoFilterSelector = (state) => state.hostInfo.filter;
export const hostInfoPaginationSelector = (state) => state.hostInfo.pagination;